import app from 'app';
import ready from 'utils/ready';

import searchPage from './search/main';

app.add({
  searchPage,
});

ready(app.mount);
